import api from "./api";
import { getUser } from "../services/Auth";

export const GetEntregadoresEmpresaOuData = async (id, data) => {
  try {
    const pedidos = await api.post(
      `/entregadores/estabelecimento/${id}/empresa-data`,
      data,
    );
    return pedidos.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarEntregador = async (dados, dadosEndereco, dadosUsuario) => {
  try {
    const endereco = await api.post(`/enderecos`, dadosEndereco);
    const usuario = await api.post(`/registrar`, dadosUsuario);

    if (endereco.data && usuario.data.usuario) {
      dados = {
        ...dados,
        endereco: endereco.data._id,
        usuario: usuario.data.usuario._id,
      };
      const entregadores = await api.post(`/entregadores`, dados);
      return entregadores.data;
    }
  } catch (error) {
    throw error;
  }
};

export const DeletarEntregador = async (dados) => {
  try {
    const entregadores = await api.delete(`/entregadores/${dados._id}`);
    return entregadores.data;
  } catch (error) {
    throw error;
  }
};

export const EditarEntregador = async (
  dados,
  dadosEndereco,
  dadosUsuario,
  entregador,
) => {
  try {
    await api.put(`/enderecos/${entregador.endereco._id}`, dadosEndereco);
    await api.put(`/usuarios/${entregador.usuario._id}`, dadosUsuario);
    const res = await api.put(`/entregadores/${entregador._id}`, dados);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const ListarEntregadores = async (page) => {
  try {
    let usuario = await getUser();
    const entregadores = await api.get(
      `/entregadores/on-estabelecimento/${usuario.estabelecimento._id}`,
    );
    return entregadores.data;
  } catch (error) {
    throw error;
  }
};

export const MudarSenhaEntregador = async (user, senha) => {
  try {
    await api.put(`/usuarios/${user._id}/`, { senha: senha });
  } catch (error) {
    throw error;
  }
};
